export default "__VITE_ASSET__bTfz8MEG__"